module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    ref: "maskPosition",
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticStyle: {
      "height": "3.52rem"
    }
  }, [_c('p', {
    staticClass: "dialog-title"
  }, [_c('span', [_vm._v("重命名")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorInfo),
      expression: "errorInfo"
    }],
    staticStyle: {
      "color": "red",
      "display": "block",
      "font-size": "0.32rem"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.fileName),
      expression: "fileName",
      modifiers: {
        "trim": true
      }
    }],
    ref: "inputA",
    style: ({
      height: _vm.textarea ? '1.4rem' : '0.8rem'
    }),
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fileName)
    },
    on: {
      "focus": function($event) {
        _vm.focusAbsolute()
      },
      "blur": [function($event) {
        _vm.blurFixed()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileName = $event.target.value.trim()
      }
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "dialog-button"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _c('span', {
    staticClass: "ok",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确定")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.tipTitle,
      "clickCallBack": _vm.renameFile,
      "tipsType": _vm.tipsType,
      "okBtnText": _vm.okBtnText
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('confirm-tips', {
    attrs: {
      "tipTitle": _vm.extensionTitle,
      "clickCallBack": _vm.extensionTips,
      "tipsType": _vm.extensionType
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32695928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filelist/filelist_rename.vue
// module id = 215
// module chunks = 3